import * as $runtime from "../runtime.js";
import * as Data$dEuclideanRing from "../Data.EuclideanRing/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dRatio from "../Data.Ratio/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dString$dCodePoints from "../Data.String.CodePoints/index.js";
import * as Data$dString$dCommon from "../Data.String.Common/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const toStringR = r => {
  if (r._2 === 1) { return Data$dShow.showIntImpl(r._1); }
  return Data$dShow.showIntImpl(r._1) + "/" + Data$dShow.showIntImpl(r._2);
};
const toRational = dict => dict.toRational;
const toString = dictAsRational => x => toStringR(dictAsRational.toRational(x));
const fromRational = dict => dict.fromRational;
const fromString = dictAsRational => s => {
  const $0 = Data$dInt.fromString(Data$dString$dCommon.trim(s));
  const $1 = $0.tag === "Just" ? Data$dMaybe.$Maybe("Just", Data$dRatio.reduce(Data$dOrd.ordInt)(Data$dEuclideanRing.euclideanRingInt)($0._1)(1)) : Data$dMaybe.Nothing;
  const v = Data$dString$dCommon.split("/")(s);
  const $2 = (() => {
    if (v.length === 2) {
      const $2 = Data$dInt.fromString(Data$dString$dCommon.trim(v[1]));
      if ($2.tag === "Just") {
        if ($2._1 !== 0) {
          return Data$dMaybe.applyMaybe.apply((() => {
            const $3 = Data$dInt.fromString(Data$dString$dCommon.trim(v[0]));
            if ($3.tag === "Just") { return Data$dMaybe.$Maybe("Just", Data$dRatio.reduce(Data$dOrd.ordInt)(Data$dEuclideanRing.euclideanRingInt)($3._1)); }
            return Data$dMaybe.Nothing;
          })())(Data$dMaybe.$Maybe("Just", $2._1));
        }
        return Data$dMaybe.Nothing;
      }
      if ($2.tag === "Nothing") { return Data$dMaybe.Nothing; }
      $runtime.fail();
    }
    return Data$dMaybe.Nothing;
  })();
  const v$1 = Data$dString$dCommon.split(".")(Data$dString$dCommon.trim(s));
  if (v$1.length === 2) {
    const $3 = Data$dInt.fromString(v$1[0] + v$1[1]);
    if ($3.tag === "Just") {
      if ($2.tag === "Nothing") {
        if ($1.tag === "Nothing") {
          return Data$dMaybe.$Maybe(
            "Just",
            dictAsRational.fromRational(Data$dRatio.reduce(Data$dOrd.ordInt)(Data$dEuclideanRing.euclideanRingInt)($3._1)(Data$dInt.pow(10)(Data$dString$dCodePoints.toCodePointArray(v$1[1]).length)))
          );
        }
        if ($1.tag === "Just") { return Data$dMaybe.$Maybe("Just", dictAsRational.fromRational($1._1)); }
        return Data$dMaybe.Nothing;
      }
      if ($1.tag === "Nothing") {
        if ($2.tag === "Just") { return Data$dMaybe.$Maybe("Just", dictAsRational.fromRational($2._1)); }
        return Data$dMaybe.Nothing;
      }
      if ($1.tag === "Just") { return Data$dMaybe.$Maybe("Just", dictAsRational.fromRational($1._1)); }
      return Data$dMaybe.Nothing;
    }
    if ($3.tag === "Nothing") {
      if ($2.tag === "Nothing") {
        if ($1.tag === "Nothing") { return Data$dMaybe.Nothing; }
        if ($1.tag === "Just") { return Data$dMaybe.$Maybe("Just", dictAsRational.fromRational($1._1)); }
        return Data$dMaybe.Nothing;
      }
      if ($1.tag === "Nothing") {
        if ($2.tag === "Just") { return Data$dMaybe.$Maybe("Just", dictAsRational.fromRational($2._1)); }
        return Data$dMaybe.Nothing;
      }
      if ($1.tag === "Just") { return Data$dMaybe.$Maybe("Just", dictAsRational.fromRational($1._1)); }
      return Data$dMaybe.Nothing;
    }
    if ($2.tag === "Nothing") {
      if ($1.tag === "Nothing") { $runtime.fail(); }
      if ($1.tag === "Just") { return Data$dMaybe.$Maybe("Just", dictAsRational.fromRational($1._1)); }
      return Data$dMaybe.Nothing;
    }
    if ($1.tag === "Nothing") {
      if ($2.tag === "Just") { return Data$dMaybe.$Maybe("Just", dictAsRational.fromRational($2._1)); }
      return Data$dMaybe.Nothing;
    }
    if ($1.tag === "Just") { return Data$dMaybe.$Maybe("Just", dictAsRational.fromRational($1._1)); }
    return Data$dMaybe.Nothing;
  }
  if ($2.tag === "Nothing") {
    if ($1.tag === "Nothing") { return Data$dMaybe.Nothing; }
    if ($1.tag === "Just") { return Data$dMaybe.$Maybe("Just", dictAsRational.fromRational($1._1)); }
    return Data$dMaybe.Nothing;
  }
  if ($1.tag === "Nothing") {
    if ($2.tag === "Just") { return Data$dMaybe.$Maybe("Just", dictAsRational.fromRational($2._1)); }
    return Data$dMaybe.Nothing;
  }
  if ($1.tag === "Just") { return Data$dMaybe.$Maybe("Just", dictAsRational.fromRational($1._1)); }
  return Data$dMaybe.Nothing;
};
const asRationalSerialized = {fromRational: Unsafe$dCoerce.unsafeCoerce, toRational: Unsafe$dCoerce.unsafeCoerce};
const asRationalPlain = {fromRational: x => x, toRational: x => x};
export {asRationalPlain, asRationalSerialized, fromRational, fromString, toRational, toString, toStringR};
